module.exports = __webpack_public_path__ + "img/food1.d3449d1d.png";